(function () {
    angular
        .module('Controllers')
        .controller('WidgetDirectoryEntryListSettingsController', WidgetDirectoryEntryListSettingsController);

    function WidgetDirectoryEntryListSettingsController(
        $rootScope,
        $scope,
        $timeout,
        ConfigTheme,
        Content,
        ContentTemplate,
        CustomContentType,
        Directory,
        DirectoryEntryPicker,
        Features,
        InitialSettings,
        Instance,
        Metadata,
        Translation,
        Utils,
        Widget,
    ) {
        'ngInject';

        const widgetDirectoryEntryListSettings = this;
        let flatDirectoryList = []; // for selected instances

        widgetDirectoryEntryListSettings.displayDirectorySelector = displayDirectorySelector;
        widgetDirectoryEntryListSettings.isEmpty = angular.isUndefinedOrEmpty;
        widgetDirectoryEntryListSettings.keys = Object.keys;
        widgetDirectoryEntryListSettings.openDirectoryEntryPicker = openDirectoryEntryPicker;
        widgetDirectoryEntryListSettings.updateDirectoryList = updateDirectoryList;
        widgetDirectoryEntryListSettings.updateTags = updateTags;
        widgetDirectoryEntryListSettings.updateWidget = updateWidget;
        widgetDirectoryEntryListSettings.modelToSelect = modelToSelect;
        widgetDirectoryEntryListSettings.setAsMainWidget = setAsMainWidget;
        widgetDirectoryEntryListSettings.switchViewMode = switchViewMode;
        widgetDirectoryEntryListSettings.switchViewModeVariant = switchViewModeVariant;
        widgetDirectoryEntryListSettings.resetSlideshow = resetSlideshow;

        widgetDirectoryEntryListSettings.directories = {};
        widgetDirectoryEntryListSettings.tags = {};
        widgetDirectoryEntryListSettings.pickerId = `widget-directory-entry-list-picker-${Widget.getCurrent().uuid}`;
        widgetDirectoryEntryListSettings.listOrderSelection = ['createdAt', 'updatedAt', 'name'];

        widgetDirectoryEntryListSettings.modelToCustomFieldSelection = modelToCustomFieldSelection;
        widgetDirectoryEntryListSettings.customFieldToUuid = customFieldToUuid;
        widgetDirectoryEntryListSettings.customFieldsChoices = {};
        widgetDirectoryEntryListSettings.customFieldsSelected = [];

        /**
         * Alias to the CONTENT_TYPES constant.
         *
         * @type {Array}
         */
        widgetDirectoryEntryListSettings.contentTypes = InitialSettings.CONTENT_TYPES;

        widgetDirectoryEntryListSettings.Content = Content;
        widgetDirectoryEntryListSettings.CustomContentType = CustomContentType;
        widgetDirectoryEntryListSettings.Instance = Instance;
        widgetDirectoryEntryListSettings.Directory = Directory;
        widgetDirectoryEntryListSettings.Metadata = Metadata;

        $scope.$on('directory-entry-picker__close-start', function (_event, _pickerId) {
            if (_pickerId === widgetDirectoryEntryListSettings.pickerId) {
                updateWidget();
            }
        });

        // Private methods

        function init() {
            if (ConfigTheme.DIRECTORY_ENTRY_CUSTOM_SORT_ORDER) {
                widgetDirectoryEntryListSettings.listOrderSelection.push('order');
            }

            if (angular.isUndefined(Widget.getCurrent().properties.instance)) {
                Widget.getCurrent().properties.instance = [Instance.getCurrentInstanceId()];
            }

            // backward compatibility
            if (angular.isDefined(Widget.getCurrent().properties.directory)) {
                if (!angular.isArray(Widget.getCurrent().properties.directory)) {
                    // if not array cast it as it
                    if (angular.isObject(Widget.getCurrent().properties.directory)) {
                        Widget.getCurrent().properties.directory = [Widget.getCurrent().properties.directory.id];
                    } else {
                        Widget.getCurrent().properties.directory = [Widget.getCurrent().properties.directory];
                    }
                }
            }

            if (
                angular.isDefined(Widget.getCurrent().properties.instance) &&
                Widget.getCurrent().properties.instance.length > 0
            ) {
                updateDirectoryList(Widget.getCurrent().properties.instance);
            }

            function getSelectedDirectoriesIds(properties, callback) {
                if (!properties) {
                    return callback([]);
                }

                // Get ids for manual selection
                if (properties.entries && properties.entries.length > 0 && properties.type === 'pick') {
                    callback(_.uniq(_.map(properties.entries, 'directory')));
                }
                // Get ids when catalogue selected
                else if (properties.directory && properties.directory.length > 0 && properties.type !== 'pick') {
                    callback(properties.directory);
                }
                // Get ids from instance if no directories selected
                else if (properties.instance && properties.instance.length > 0) {
                    Directory.getMultiInstanceDirectories(
                        properties.instance,
                        (instances) => {
                            callback(_.uniq(_.map(instances, 'id')));
                        },
                        true,
                    );
                }
            }

            const widgetProperties = Widget.getCurrent().properties;

            getSelectedDirectoriesIds(widgetProperties, (selectedDirectoriesIds) => {
                if (selectedDirectoriesIds.length > 0) {
                    // Init custom field options for visibility
                    populateCustomFieldsVisibility(selectedDirectoriesIds);
                }
            });

            // Update custom fields options for visibility when directories or entries change
            $scope.$watch(
                function () {
                    const currentProps = Widget.getCurrent().properties;

                    return {
                        directory: currentProps.directory,
                        entries: currentProps.entries,
                        instance: currentProps.instance,
                        type: currentProps.type,
                    };
                },
                function (newValues) {
                    getSelectedDirectoriesIds(newValues, (selectedDirectoriesIds) => {
                        // Update custom field options for visibility
                        $scope.$applyAsync(function () {
                            populateCustomFieldsVisibility(selectedDirectoriesIds);
                        });
                    });
                },
                true,
            );
        }

        /**
         * Build tag select with header
         * @param directoriesIds
         */
        function buildTagHeaderList(directoriesIds) {
            const tags = {};

            if (!Widget.getCurrent().isMainWidget || !Directory.getCurrent()) {
                angular.forEach(flatDirectoryList, function forEachDirectory(dir) {
                    if (
                        angular.isDefinedAndFilled(directoriesIds) &&
                        angular.isDefinedAndFilled(dir.id) &&
                        _.includes(directoriesIds, dir.id) &&
                        angular.isDefinedAndFilled(dir.tags)
                    ) {
                        tags[Translation.translate(dir.name)] = dir.tags;
                    }
                });

                /**
                 * Extract all available tags based on currently selected directory ids.
                 * */
                const availableTags = flatDirectoryList
                    .filter(
                        (directory) => directory.id && directory.tags && (directoriesIds ?? []).includes(directory.id),
                    )
                    .flatMap(({ tags }) => tags);
                /**
                 * Remove all outdated tags.
                 * Iterate through all currently selected tags, and check that they are still available.
                 * */
                const modelKeep = (Widget.getCurrent().properties.directoryTags ?? []).filter((selectedTag) =>
                    availableTags.some((tag) => tag.uuid === selectedTag),
                );

                Widget.getCurrent().properties.directoryTags = modelKeep;
                widgetDirectoryEntryListSettings.tags = tags;
            } else {
                widgetDirectoryEntryListSettings.tags[Translation.translate(Directory.getCurrent().name)] =
                    Directory.getCurrent().tags;
            }
        }

        /**
         * Populates customFields for specified directory IDs
         * @param {Array} directoryIds - Array of directory IDs to process
         */
        function populateCustomFieldsVisibility(directoryIds) {
            const customFieldsData = {};

            // If no directory ids clear choices and selected customer fields
            if (!directoryIds || directoryIds.length <= 0) {
                widgetDirectoryEntryListSettings.customFieldsChoices = {};
                widgetDirectoryEntryListSettings.customFieldsSelected = [];
                Widget.getCurrent().properties.customFieldsVisibility = {};
                return;
            }

            // Add ALL custom fields from the currently selected directories
            directoryIds.forEach((dirId) => {
                const directory = Directory.getById(dirId);
                if (directory && directory.template && directory.template.components.length > 0) {
                    // Use directory name as a key for grouping in choices as it's displayed in UI
                    customFieldsData[Translation.translate(directory.name)] = directory.template.components;
                }
            });
            // Set customFieldsChoices up to date with all custom fields
            widgetDirectoryEntryListSettings.customFieldsChoices = customFieldsData;

            // Create a Set of unique UUIDs available from the current directories
            const allAvailableUuidsFromCurrentDirectories = new Set(
                _.flatMap(customFieldsData, (formFields) => _.map(formFields, 'uuid')),
            );

            // Get already saved custom fields
            const oldCustomFieldsVisibility = Widget.getCurrent().properties.customFieldsVisibility || {};

            const newCustomFieldsVisibility = {};
            const newSelectedCustomFieldUuids = [];

            // Manage selected custom field
            for (const uuid of allAvailableUuidsFromCurrentDirectories) {
                // Keep field already set to false to false
                if (oldCustomFieldsVisibility.hasOwnProperty(uuid) && oldCustomFieldsVisibility[uuid] === false) {
                    newCustomFieldsVisibility[uuid] = false;
                } else {
                    // Add all other field in allAvailableUuidsFromCurrentDirectories set to true
                    newCustomFieldsVisibility[uuid] = true;
                    newSelectedCustomFieldUuids.push(uuid);
                }
            }

            // Update widget state
            widgetDirectoryEntryListSettings.customFieldsSelected = newSelectedCustomFieldUuids;
            Widget.getCurrent().properties.customFieldsVisibility = newCustomFieldsVisibility;
        }

        /**
         * Convert custom field UUID to selection object
         * @param {Array} data - Array of UUIDs
         * @param {Function} callback - Callback function
         */
        function modelToCustomFieldSelection(data, callback) {
            if (!data) {
                return;
            }

            const currentField = _.find(
                _.flatMap(widgetDirectoryEntryListSettings.customFieldsChoices, function (directoryFields) {
                    return directoryFields;
                }),
                function (field) {
                    return field && field.uuid === data;
                },
            );

            if (currentField) {
                callback(currentField);
            } else {
                console.warn('Expected array of UUIDs but received:', data);
            }
        }

        /**
         * Convert selection object to custom field UUID
         * @param {Array} data - Array of selected custom field objects
         * @param {Function} callback - Callback function
         */
        function customFieldToUuid(data, callback) {
            if (!data) {
                return;
            }

            // Update saved options
            const currentFieldValue = Widget.getCurrent().properties.customFieldsVisibility[data.uuid];
            Widget.getCurrent().properties.customFieldsVisibility[data.uuid] = !currentFieldValue;

            // Display option
            callback(data.uuid);
        }

        // Public methods

        function resetSlideshow() {
            Widget.getCurrent().properties.slideshowEnabled = false;
            Widget.getCurrent().properties.slideshowAutoPlay = false;
            delete Widget.getCurrent().properties.slideshowInterval;
        }

        /**
         * Check if directory selector can be displayed
         */
        function displayDirectorySelector() {
            return (
                angular.isDefined(Widget.getCurrent().properties.instance) &&
                Widget.getCurrent().properties.instance.length &&
                angular.isDefinedAndFilled(widgetDirectoryEntryListSettings.directories)
            );
        }

        /**
         * Open directory entry picker
         */
        function openDirectoryEntryPicker() {
            Utils.waitForAndExecute(`#${widgetDirectoryEntryListSettings.pickerId}`, DirectoryEntryPicker);
        }

        /**
         * Update tag list
         */
        function updateTags() {
            buildTagHeaderList(Widget.getCurrent().properties.directory);
            updateWidget();
        }

        /**
         * Update widget on settings change
         */
        function updateWidget() {
            $timeout(function () {
                $rootScope.$broadcast('widget-directory-entry-list-settings', Widget.getCurrent().uuid);
            });
        }

        /**
         * Model to selection
         * @param data
         * @param callback
         * @param haystack
         * @param identifier
         */
        function modelToSelect(data, callback, haystack, identifier) {
            for (const key in haystack) {
                if (haystack.hasOwnProperty(key)) {
                    const needle = _.find(haystack[key], function (n) {
                        return n[identifier] === data;
                    });

                    if (angular.isDefined(needle)) {
                        (callback || _.noop)(needle);
                    }
                }
            }
        }

        /**
         * Update the list of directory
         * @param selectedInstances
         */
        function updateDirectoryList(selectedInstances) {
            // build select /w/ header
            Directory.getMultiInstanceDirectories(selectedInstances, function (list, dirIds) {
                // intersection, only keep ids that are in both list
                Widget.getCurrent().properties.directory = _.intersection(
                    Widget.getCurrent().properties.directory,
                    dirIds,
                );
                widgetDirectoryEntryListSettings.directories = list;

                // get flat directory list
                for (const instance in list) {
                    if (list.hasOwnProperty(instance) && angular.isArray(list[instance])) {
                        flatDirectoryList = flatDirectoryList.concat(list[instance]);
                    }
                }

                updateTags();
            });
        }

        /**
         * If this widget is now a "Main Widget", remove the isMainWidget attribute to the other widgets.
         */
        function setAsMainWidget() {
            const currentWidget = Widget.getCurrent();
            if (currentWidget.isMainWidget) {
                const _widgetList = ContentTemplate.getElementList(
                    Content.getCurrent(),
                    'widget',
                    'isMainWidget',
                    true,
                );
                angular.forEach(_widgetList, function forEachWidget(widget) {
                    if (widget.uuid !== currentWidget.uuid) {
                        widget.isMainWidget = false;
                    }
                });
            }

            $rootScope.$broadcast('widget-is-main-toggled', currentWidget.uuid, currentWidget.isMainWidget);
        }

        /**
         * Switch widget view mode.
         *
         * @param {string} viewMode The wanted view mode
         */
        function switchViewMode(viewMode) {
            if (Widget.getCurrent().properties.viewMode === viewMode) {
                return;
            }

            Widget.getCurrent().properties.viewMode = viewMode;
            Widget.getCurrent().properties.viewModeVariant = 'group';

            if (viewMode === 'list') {
                widgetDirectoryEntryListSettings.resetSlideshow();
            }

            widgetDirectoryEntryListSettings.updateWidget();
        }

        /**
         * Switch widget view mode variant.
         *
         * @param {string} viewModeVariant The wanted view mode variant
         */
        function switchViewModeVariant(viewModeVariant) {
            if (Widget.getCurrent().properties.viewModeVariant === viewModeVariant) {
                return;
            }

            Widget.getCurrent().properties.viewModeVariant = viewModeVariant;

            widgetDirectoryEntryListSettings.updateWidget();
        }

        /**
         * When instance siblings selector is reset, reset all filters.
         */
        $scope.$on('reset-instance-siblings-selector', function onInstanceSiblingsSelectorReset() {
            const _properties = Widget.getCurrent().properties;

            _properties.instance = [Instance.getCurrentInstanceId()];
            _properties.directory = [];
            _properties.directoryTags = [];
            _properties.metadata = [];
        });

        init();
    }
})();
